import { fetchEventSource } from '@microsoft/fetch-event-source'

export default {
  deepClone(obj) {
    // 如果传入的不是对象或者为 null，则直接返回
    if (typeof obj !== 'object' || obj === null) {
      return obj
    }

    let clone
    // 判断是数组还是对象
    if (Array.isArray(obj)) {
      clone = []
      for (let i = 0; i < obj.length; i++) {
        clone[i] = this.deepClone(obj[i])
      }
    } else {
      clone = {}
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          clone[key] = this.deepClone(obj[key])
        }
      }
    }
    return clone
  },
  //深拷贝
  mergeDeep(target, ...sources) {
    if (!sources.length) return target
    const source = sources.shift()

    if (typeof target === 'object' && typeof source === 'object') {
      for (const key in source) {
        if (typeof source[key] === 'object') {
          if (!target[key]) Object.assign(target, { [key]: {} })
          this.mergeDeep(target[key], source[key])
        } else {
          Object.assign(target, { [key]: source[key] })
        }
      }
    }

    return this.mergeDeep(target, ...sources)
  },
  
  // JSON字符串单引号转为双引号
  parseSingleQuotedJSON(jsonString) {
    try {
      // 把单引号替换成双引号
      let doubleQuotedString = jsonString.replace(/'/g, '"')
      // 解析处理后的字符串
      return JSON.parse(doubleQuotedString)
    } catch (error) {
      console.log('解析 JSON 时出错:', jsonString, error)
      return null
    }
  },

  //创建SSE请求
  createSSEConnection(url, onMessage, onError, onOpen) {
    const eventSource = new EventSource(url)

    eventSource.onopen = () => {
      if (typeof onOpen === 'function') {
        onOpen()
      }
    }

    eventSource.onmessage = (event) => {
      if (typeof onMessage === 'function') {
        try {
          const fullData = event.data
          // 处理数据的代码
          onMessage(fullData)
        } catch (error) {
          console.error('处理数据时出错:', error)
        }
      }
    }

    eventSource.onerror = (error) => {
      if (typeof onError === 'function') {
        onError(error)
      }
      eventSource.close()
    }

    return () => {
      console.log('关闭事件源连接')
      eventSource.close()
    }
  },

  // 创建post请求的SSE请求
  startEventSource(url, data, onMessage, onError, onOpen) {
    const formUrlEncodedData = Object.keys(data)
      .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&')

    const abortController = new AbortController()
    const signal = abortController.signal

    try {
      fetchEventSource(url, {
        method: 'post',
        body: formUrlEncodedData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        signal,
        onopen: () => {
          if (typeof onOpen === 'function') {
            onOpen()
          } else {
            console.log('连接已建立')
          }
        },
        onmessage: (event) => {
          if (typeof onMessage === 'function') {
            try {
              const fullData = event.data
              onMessage(fullData)
            } catch (error) {
              console.error('处理数据时出错:', error)
            }
          } else {
            return fullData
          }
        },
        onerror: (error) => {
          if (typeof onError === 'function') {
            onError(error)
          } else {
            console.error('事件源连接出错:', error)
          }
          abortController.abort()
        },

        openWhenHidden: true, //隐藏页面停止请求，显示页面重新请求
      })
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('事件源连接已被手动关闭')
      } else {
        console.error('启动事件源失败:', error)
      }
    }

    return () => {
      abortController.abort()
    }
  },
}
